import React from 'react';
import {Container, Image} from "react-bootstrap";

const Welcome = () => {
    return (
        <Container>
            <Image src={"/images/logo.svg"} alt="logo" />
            <h2 color={'green'}>SHOPLY</h2>
            <h5>версия 1.0</h5>
            <p>Сервис доставки продуктов</p>
            <p>Shoply – это удобное мини-приложение на базе Telegram Bot для заказа продуктов с доставкой на дом. С нами вы экономите время и усилия, получая качественные продукты быстро и с заботой!</p>
            <a href={'https://t.me/gatami_bot'}>Вход</a>
        </Container>
    );
};

export default Welcome;